import { createContext } from '@rc-component/context';
var TableContext = createContext();
export default TableContext;